import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import '../style/Loader.less';

function Loader() {
    const [t] = useTranslation();
    const show = useSelector(state => state.loader.show);

    if (!show) {
        return null;
    }

    return (
        <div className="overlay">
            <div className="loader-container">
                <span className="sr-only">{t('Common.LOADING')}</span>
                <div className="loader-roller">
                    {/* All divs are necessary */}
                    <div/>
                    <div/>
                    <div/>
                    <div/>
                    <div/>
                    <div/>
                    <div/>
                    <div/>
                </div>
            </div>
        </div>
    );
}

export default Loader;
